export default __webpack_public_path__ + "static/media/advantages.74d65902.png";